/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ---- Accessibility-tree patch for AI agents (Lighthouse agentic-browsing) ----
 * Resolves the three "agent-accessibility-tree" failures without touching theme markup:
 *   1) removes the unsupported aria-expanded from the static cart-icon <div>
 *      (the toggle behaviour stays driven by the parent <a>, which keeps aria-expanded)
 *   2) keeps focusable elements out of aria-hidden Flickity carousel cells
 *   3) gives the Reputon eBay-reviews link a discernible accessible name
 * Also moves the floating T Lab language switcher just below the cart (top:120px
 * desktop / 110px mobile, right) at every screen size so it clears the cart button
 * while the dropdown keeps the full viewport height below it to scroll all
 * languages (T Lab is the working switcher).
 * Idempotent + MutationObserver so it also covers client-rendered widgets. */
(function () {
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function injectCss() {
    if (document.getElementById('claude-theme-fixes')) return;
    var s = document.createElement('style');
    s.id = 'claude-theme-fixes';
    s.textContent = '.tl-switcher-container.tl-custom-position{position:fixed !important;top:120px !important;right:20px !important;bottom:auto !important;left:auto !important;}@media (max-width:640px){.tl-switcher-container.tl-custom-position{top:110px !important;right:10px !important;}}';
    (document.head || document.documentElement).appendChild(s);
  }

  function hasName(el) {
    var al = el.getAttribute('aria-label');
    if (al && al.trim()) return true;
    if (el.getAttribute('aria-labelledby')) return true;
    var t = el.getAttribute('title');
    if (t && t.trim()) return true;
    if (el.textContent && el.textContent.trim()) return true;
    var img = el.querySelector('img[alt]');
    return !!(img && img.getAttribute('alt') && img.getAttribute('alt').trim());
  }

  function patch() {
    document.querySelectorAll('.header__cart-icon[aria-expanded]').forEach(function (el) {
      el.removeAttribute('aria-expanded');
    });

    document.querySelectorAll('a.reputon-link').forEach(function (a) {
      if (!hasName(a)) a.setAttribute('aria-label', 'Avis clients eBay de IT and Office');
    });

    document.querySelectorAll('.flickity-slider [aria-hidden="true"]').forEach(function (cell) {
      cell.querySelectorAll(FOCUSABLE).forEach(function (el) {
        if (el.getAttribute('tabindex') !== '-1') {
          el.setAttribute('data-a11y-prev', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : 'none');
          el.setAttribute('tabindex', '-1');
        }
      });
    });

    document.querySelectorAll('[data-a11y-prev]').forEach(function (el) {
      if (!el.closest('[aria-hidden="true"]')) {
        var prev = el.getAttribute('data-a11y-prev');
        if (prev === 'none') { el.removeAttribute('tabindex'); } else { el.setAttribute('tabindex', prev); }
        el.removeAttribute('data-a11y-prev');
      }
    });
  }

  function init() {
    injectCss();
    patch();
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; patch(); });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
